/*eslint-disable */
import root from '../_helpers/roots';
import axios from 'axios';
let UserTaskUrl = root.userTaskUrl.link;
let TaskReadUrl = root.taskReadUrl.link;
import Vue from 'vue'
export default {
  state: {
    getUserTaskState:{},
    getUserDetailsByIdState:{}
  },
  mutations: {
    getUserTaskMut(state, value) {
      Vue.set(state, 'getUserTaskState', value);
    },
    getUserDetailsByIdMut(state, value) {
      Vue.set(state, 'getUserDetailsByIdState', value);
    }
  },
  actions: {
    // Get User Task List
    getUserTaskListFun(context, payload) {
        return new Promise((resolve, reject) => {
            axios.get(UserTaskUrl + payload.id + '/').then(res => {
              context.commit('getUserTaskMut', res.data);
              resolve(res);
            }).catch(err => {
              reject(err);
            })
        })
    },
    // Get Task Details BY Id 
    getTaskDetailsByIdFun(context, payload) {
        return new Promise((resolve, reject) => {
            axios.get(TaskReadUrl + payload.id + '/').then(res => {
              context.commit('getUserDetailsByIdMut', res.data);
              resolve(res);
            }).catch(err => {
              reject(err);
            })
        })
    },
    // Get Task Details BY Id 
    removeTaskDetailsFun(context, payload) {
        return new Promise((resolve, reject) => {
            axios.delete(TaskReadUrl + payload.id + '/').then(res => {
              resolve(res);
            }).catch(err => {
              reject(err);
            })
        })
    }
  },
  getters: {
    getUserTaskGetters: state => state.getUserTaskState,
    getUserDetailsByIdGetters: state => state.getUserDetailsByIdState
  }
}